// ═══════════════════════════════════════════════════════════════════
//  composants/Badge.js
//  Badge
// ═══════════════════════════════════════════════════════════════════

export function Badge({ text, bg, color }) {
  return (
    <span style={{ background: bg, color, borderRadius: 4, padding: "2px 8px", fontSize: 11, fontWeight: 600, whiteSpace: "nowrap" }}>
      {text}
    </span>
  );
}
